import * as React from 'react';
import {Input} from 'antd';
import {useState} from "react";
import {REGEX_PATTERNS} from '../../constants/regex';


//TODO: use InputProps and send mode in this options


interface SearchInputProps {
  value?: string;
  onChange: (filter: object) => any;
}

const MobileInput: React.FC<SearchInputProps> = props => {
  const {value, onChange} = props;
  
  const handleKeyDown = (event) => {
    const theEvent = event || window.event;
    let key;
    let isValid = true;
    // Handle paste
    if (theEvent.type === 'paste') {
      key = event.clipboardData.getData('text/plain');
    }
    else {
      key = event.key
    }
  
    if (event.ctrlKey || event.altKey
        || (47 < event.keyCode && event.keyCode < 58 && event.shiftKey == false)
        || (95 < event.keyCode && event.keyCode < 106)
        || (event.keyCode == 8) || (event.keyCode == 9)
        || (event.keyCode > 34 && event.keyCode < 40)
        || (event.keyCode == 46)
      ) {
      return;
    }
  
    if (!/^[0-9\.\(\)\/\+\-\s@]*$/.test(key)) {
      isValid = false;
    }
  
    if (!isValid) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  };
  
  return (
    <input
      className={'ant-input'}
      value={value}
      onKeyDown={handleKeyDown}
      onChange={onChange}
    />
  )
  
};

export default MobileInput